module.exports = __webpack_public_path__ + "static/CloudBatteryHero-61787bcaacedf2e05becaf979b8cd0df.svg";